// Tour step properties:
//   - aboveDrawer: (bool) step targets an element inside a drawer overlay — adjusts z-index accordingly
//   - awaitClick: (string) CSS selector — the tour pauses until the user clicks this element
//   - awaitClickAdvanceDelay: (number) ms to wait after the click before moving to the next step
//   - awaitClickAll: (bool) listen for click on ALL elements matching awaitClick, not just the first
//   - awaitClickDelegate: (bool) use event delegation for awaitClick — resilient to DOM re-renders (e.g. FullCalendar)
//   - awaitClickLast: (bool) target the last matching element and block clicks on all others
//   - blockClickOnlySelectors: (string[]) CSS selectors whose click events are blocked (mousedown allowed for drag-and-drop)
//   - blockClickSelectors: (string[]) CSS selectors whose click AND mousedown events are blocked
//   - blockTarget: (bool|string) true = block clicks on the spotlight target; string = block clicks on that selector
//   - blockTargetException: (string|string[]) inside a blocked target, these selectors stay clickable
//   - blockTargetSiblings: (bool) block all siblings inside the target container, only the awaitClick element stays clickable
//   - congrats: (bool) marks the final congratulatory step (triggers confetti)
//   - content: (string) i18n key for the step body text
//   - hideFinish: (bool) hide the Finish button (used when chaining to another tour)
//   - hidePrev: (bool) hide the Previous button for this step
//   - highlightDays: (bool) add a pulsing highlight to calendar day cells
//   - nextTour: (string) id of the tour to start when this step or tour ends (chaining)
//   - noSpotlight: (bool) disable the spotlight cutout (full overlay, e.g. for congrats)
//   - position: (string) tooltip placement relative to the target — top | bottom | left | right | center
//   - pulse: (bool) show a pulsing animation on the awaitClick element (default: true when awaitClick is set)
//   - raiseAncestors: (bool) raise ancestor stacking contexts so the target escapes its parent z-index
//   - scrollTo: (string) 'top' scrolls the page to top instead of centering the target
//   - spotlightPadding: (number) extra px around the target in the spotlight cutout
//   - target: (string) CSS selector of the element to highlight
//   - title: (string) i18n key for the step title
//   - watchTargets: (string[]) extra CSS selectors included in the spotlight area

import { watch } from "vue";

export default {
  id: 'plannerReturn',
  route: 'posts2',
  steps: [
    // --- Step 1: Calendar overview (back from post creator) ---
    {
      target: '.days-cells',
      title: 'tours.plannerReturn.steps.calendar.title',
      content: 'tours.plannerReturn.steps.calendar.content',
      position: 'left',
      spotlightPadding: 4,
      blockClickSelectors: ['.day-cell'],
      blockClickOnlySelectors: ['.container-event'],
      blockOutsideSpotlight: true
    },
    // --- Step 2: Click on a scheduled post to open the drawer ---
    {
      target: '.days-cells',
      title: 'tours.plannerReturn.steps.clickPost.title',
      content: 'tours.plannerReturn.steps.clickPost.content',
      position: 'left',
      spotlightPadding: 4,
      awaitClick: '.container-event',
      awaitClickDelegate: true,
      blockClickSelectors: ['.day-cell'],
      blockOutsideSpotlight: true
    },
    // --- Step 3: Post drawer overview ---
    {
      target: '.post-drawer .drawer',
      title: 'tours.plannerReturn.steps.drawer.title',
      content: 'tours.plannerReturn.steps.drawer.content',
      position: 'left',
      aboveDrawer: true,
      blockTarget: true,
      blockOutsideSpotlight: true
    },
    // --- Step 4: Drawer action buttons ---
    {
      target: '.post-drawer .drawer-render .actions',
      title: 'tours.plannerReturn.steps.drawerActions.title',
      content: 'tours.plannerReturn.steps.drawerActions.content',
      position: 'left',
      blockTarget: true,
      aboveDrawer: true,
      blockOutsideSpotlight: true
    },
    // --- Step 5: Drawer navigation ---
    {
      target: '.post-drawer .drawer-navigation',
      title: 'tours.plannerReturn.steps.drawerNav.title',
      content: 'tours.plannerReturn.steps.drawerNav.content',
      watchTargets: ['.modal-popup .popup, .container-select-user'],
      position: 'top',
      aboveDrawer: true,
      blockOutsideSpotlight: true
    },
    // --- Congrats (chains to bots tour) ---
    {
      title: 'tours.plannerReturn.steps.congrats.title',
      content: 'tours.plannerReturn.steps.congrats.content',
      position: 'center',
      noSpotlight: true,
      congrats: true,
      nextTour: 'reporting',
      blockOutsideSpotlight: true
    }
  ]
}
